"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'Panel',
  props: {
    title: {
      type: String,
      default: ''
    },
    noTitle: {
      type: Boolean,
      default: false
    }
  }
};